<div fxLayout.gt-md="row" fxLayout="column" fxLayoutAlign="space-between stretch">

  <mat-card fxFlex="100">
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
             fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>
            Building Materials |
            <span *ngIf="isNewBuildingMaterialFeed" class="text-warning ifc-link" (click)="toggleNewBuildingMaterialSettings()"
                  matBadgeColor="warn" [matBadge]="buildingMaterialSettings.length" matBadgeOverlap="false">
              Show
              Existing
            </span>
            <span *ngIf="!isNewBuildingMaterialFeed" class="text-success ifc-link" (click)="toggleNewBuildingMaterialSettings()"
                  matBadgeColor="accent" [matBadge]="newBuildingMaterialSettings.length" matBadgeOverlap="false">Show New</span>
          </label>

          <button type="button" class="add-action-button" mat-flat-button color="accent" (click)="saveBuildingMaterialSettings()"
                  [disabled]="!isBuildingMaterialSettingsDirty || loading">
            <mat-icon>done</mat-icon> Save
          </button>
        </div>

        <ng-container *ngIf="isNewBuildingMaterialFeed">
          <mat-card *ngFor="let buildingMaterialSetting of pagedNewBuildingMaterialSettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Building Material Name</mat-label>
                <input type="text" matInput placeholder="Building Material Name" [(ngModel)]="buildingMaterialSetting.buildingMaterialName" readonly>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Building Material Tag</mat-label>
                <mat-select [(ngModel)]="buildingMaterialSetting.buildingMaterialTag" #buildingMaterialTagType="ngModel" required>
                  <mat-option *ngFor="let item of buildingMaterialTagKeyValues" [value]="item.value.buildingMaterialTag">
                    {{ item.value.buildingMaterialTag }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="buildingMaterialTagType.errors?.['required']">
                  Building Material Tag is <strong>required</strong>
                </mat-error>

                <mat-hint *ngIf="showSuggestedBuildingMaterialSettings(buildingMaterialSetting)"
                          class="text-warning ifc-link" align="end" (click)="useSuggestedBuildingMaterialSettings(buildingMaterialSetting)">
                  set to
                  {{buildingMaterialSetting.suggestedBuildingMaterialSettings.buildingMaterialName}}?
                </mat-hint>
              </mat-form-field>

              <div fxLayout="column">
                <mat-checkbox [(ngModel)]="buildingMaterialSetting.shouldCreateSkirtingAndCornice" #shouldCreateSkirtingAndCornice="ngModel">Should Create Skirting and Cornice</mat-checkbox>
              </div>
            </mat-card-content>
          </mat-card>

          <div *ngIf="newBuildingMaterialSettings.length == 0 && !loading">
            No new building materials to configure, perfect!
          </div>

          <div *ngIf="newBuildingMaterialSettings.length == 0 && loading">
            Loading building material settings...
          </div>

          <mat-paginator *ngIf="newBuildingMaterialSettings.length" (page)="onNewBuildingMaterialsPageChange($event)"
                         [pageIndex]="newBuildingMaterialSettingsPageIndex" [length]="newBuildingMaterialSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>

        <ng-container *ngIf="!isNewBuildingMaterialFeed">
          <mat-card *ngFor="let buildingMaterialSetting of pagedBuildingMaterialSettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Building Material Name</mat-label>
                <input type="text" matInput placeholder="Building Material Name" [(ngModel)]="buildingMaterialSetting.buildingMaterialName" readonly>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Building Material Tag</mat-label>
                <mat-select [(ngModel)]="buildingMaterialSetting.buildingMaterialTag" #buildingMaterialTagType="ngModel" required>
                  <mat-option *ngFor="let item of buildingMaterialTagKeyValues" [value]="item.value.buildingMaterialTag">
                    {{ item.value.buildingMaterialTag }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="buildingMaterialTagType.errors?.['required']">
                  Building Material Tag is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <div fxLayout="column">
                <mat-checkbox [(ngModel)]="buildingMaterialSetting.shouldCreateSkirtingAndCornice" #shouldCreateSkirtingAndCornice="ngModel">Should Create Skirting and Cornice</mat-checkbox>
              </div>

              <button mat-icon-button color="accent" aria-label="Remove" (click)="removeBuildingMaterialSetting(buildingMaterialSetting);">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>

          <div *ngIf="buildingMaterialSettings.length == 0 && !loading">
            No building materials have been configured.
          </div>

          <div *ngIf="buildingMaterialSettings.length == 0 && loading">
            Loading building material settings...
          </div>

          <mat-paginator *ngIf="buildingMaterialSettings.length" (page)="onBuildingMaterialsPageChange($event)"
                         [pageIndex]="buildingMaterialSettingsPageIndex" [length]="buildingMaterialSettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card ngStyle.gt-md="max-width: 450px;">
    <mat-card-content>
      <h2>Documentation</h2>

      <p>This configuration enables functionality on a per material basis.</p>
      <h3>How are Building Materials Used</h3>
      <p>This page lists building materials that are used in the CAD drawings.</p>
      <p>Situ Systems has the ability to apply different &quot;themes&quot; including bricks, tiles, paints, carpeting etc.</p>
      <p>Themes allow you to match up the materials in the CAD drawings with a selection of high quality real products from real businesses.</p>
      <h3>Choosing a Building Material</h3>
      <p>Select a Building Material pre-set that most closely matches the building material type. When this material is found in the house it will be replaced with the material selected in the theme.</p>
      <p>Selecting <code>Generic Material</code> will not use material tags to replace the materials and instead will use the items type to do the material replacement. For example an item that is classified as a kitchen benchtop would get the Stone Benchtop material applied to it.</p>
      <p><code>Not Themed</code> is useful for materials that do not need theming as they are not visible in a house. Materials such as cavity, void and air and frames should use this option.</p>
      <p><code>Do Not Import</code> will completely remove any surfaces with this material while building out a house.</p>
      <h3>Building Material Options</h3>
      <h4>Should Create Skirting and Cornice</h4>
      <p>Check to enable walls with this material to generate Skirting and Cornice. Generally Plasterboard Wall materials should have this enabled.</p>

    </mat-card-content>
  </mat-card>

</div>
